export default __webpack_public_path__ + "static/assets/AllianceNo2Semibold.66293711.woff";